import { render, staticRenderFns } from "./UniversalSearch.vue?vue&type=template&id=74dda168&scoped=true"
import script from "./UniversalSearch.vue?vue&type=script&lang=js"
export * from "./UniversalSearch.vue?vue&type=script&lang=js"
import style0 from "./UniversalSearch.vue?vue&type=style&index=0&id=74dda168&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dda168",
  null
  
)

export default component.exports